import { render } from "./ModalTheme.vue?vue&type=template&id=348ebbae&ts=true"
import script from "./ModalTheme.vue?vue&type=script&lang=ts"
export * from "./ModalTheme.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__